/**
 * Bijou Candles: keep the mobile "Your pick" strip (snippets/product-form.liquid) in sync with the selected variant.
 * Focal fires `variant:changed` on the product form whenever the shopper changes an option (see assets/custom.js).
 */
(function () {
  function formatMoney(cents) {
    var settings = (window.themeVariables && window.themeVariables.settings) || {};
    var format = (settings.currencyCodeEnabled ? settings.moneyWithCurrencyFormat : settings.moneyFormat) || '$ {{amount}}';
    var amount = (cents / 100).toFixed(2);
    var withThousands = amount.replace(/\B(?=(\d{3})+(?!\d))/g, ',');

    return format
      .replace('{{amount_no_decimals}}', (cents / 100).toFixed(0))
      .replace('{{amount_with_comma_separator}}', amount.replace('.', ','))
      .replace('{{amount}}', withThousands);
  }

  function imageUrl(src, width) {
    if (!src) {
      return null;
    }

    var url = src.indexOf('//') === 0 ? 'https:' + src : src;
    return url + (url.indexOf('?') === -1 ? '?' : '&') + 'width=' + width;
  }

  /**
   * The strip's Add to Cart only appears once the main Add to Cart has scrolled up past the pinned strip,
   * so there is never two buttons on screen at once.
   */
  var passedObserver = null;
  var watchedButton = null;

  function watchAddToCart() {
    var strip = document.querySelector('.bijou-pick');
    // Watch the button itself (not the whole payment block), so the strip's button appears the moment it is hidden
    var addToCart = document.getElementById('AddToCart') || document.getElementById('MainPaymentContainer');

    if (passedObserver) {
      passedObserver.disconnect();
      passedObserver = null;
      watchedButton = null;
    }

    if (!strip || !addToCart || !('IntersectionObserver' in window)) {
      return;
    }

    var row = strip.querySelector('.bijou-pick__row');
    var pinnedHeight = (parseFloat(getComputedStyle(strip).top) || 0) + (row ? row.offsetHeight : 0) + 12;

    passedObserver = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        // The theme swaps the buy buttons out on variant change; a detached button reports an empty box,
        // which would read as "scrolled past" and flash the strip's button. Ignore it and wait for the new one.
        if (!entry.target.isConnected || entry.boundingClientRect.height === 0) {
          return;
        }

        var passed = !entry.isIntersecting && entry.boundingClientRect.top < window.innerHeight / 2;
        strip.classList.toggle('is-passed', passed);
      });
    }, { rootMargin: '-' + Math.round(pinnedHeight) + 'px 0px 0px 0px' });

    passedObserver.observe(addToCart);
    watchedButton = addToCart;
  }

  function start() {
    watchAddToCart();

    // Re-attach as soon as the theme replaces the buy buttons (variant change re-render)
    if ('MutationObserver' in window) {
      var scope = document.querySelector('.shopify-section--main-product') || document.body;

      new MutationObserver(function () {
        var live = document.getElementById('AddToCart') || document.getElementById('MainPaymentContainer');

        if (live && live !== watchedButton) {
          watchAddToCart();
        }
      }).observe(scope, { childList: true, subtree: true });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }

  document.addEventListener('variant:changed', function (event) {
    var variant = event.detail && event.detail.variant;

    if (!variant) {
      return;
    }

    var form = event.target;
    var scope = (form && form.closest && form.closest('.shopify-section')) || document;
    var strips = scope.querySelectorAll('.bijou-pick');

    if (!strips.length) {
      return;
    }

    var styleEl = scope.querySelector('.bijou-style-selector .product-form__option-value');
    var parts = [];

    if (styleEl && styleEl.textContent.trim()) {
      parts.push(styleEl.textContent.trim());
    }

    (variant.options || []).forEach(function (option) {
      if (option) {
        parts.push(option);
      }
    });

    var media = null;

    if (variant.featured_media && variant.featured_media.preview_image) {
      media = variant.featured_media.preview_image.src;
    } else if (variant.featured_image) {
      media = variant.featured_image.src;
    }

    strips.forEach(function (strip) {
      var value = strip.querySelector('.bijou-pick__value');
      var price = strip.querySelector('.bijou-pick__price');
      var image = strip.querySelector('.bijou-pick__image');

      if (value) {
        value.textContent = parts.join(' · ');
      }

      if (price) {
        price.textContent = formatMoney(variant.price);
      }

      if (image && media) {
        image.removeAttribute('srcset');
        image.src = imageUrl(media, 132);
      }
    });
  });
})();
